import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";
import zIndexes from "zIndexes.module.scss";

export const useStyles = makeStyles<Theme>(() => ({
  root: {
    willChange: "transform",
    backfaceVisibility: "hidden",
    display: "block",
    position: "absolute",
    zIndex: zIndexes.panContainerZIndex,
    top: "0",
    left: "0",
    touchAction: "none",
  },
}));
